module.exports = __webpack_public_path__ + "static/media/Brunch.b042d955.png";